const GroupAccessTypesMapping = Object.freeze({
  0: 'Local', // Access is limited to only the user's group.
  1: 'LocalUp', // Access is the user's group and all parent group up to the top.
  2: 'LocalUpDown' // Acces is the local group, all parent groups, and all child groups.
});

export default GroupAccessTypesMapping;